import useAppModal from 'hooks/useAppModal';
import { useTranslation } from 'react-i18next';
import { AdditionalManualReviewPayload } from 'models/automation/Reviews';
import AddEditReviewTemplateModal from './AddEditReviewTemplateModal';

const addEditReviewTemplateModalId = 'add-edit-review-template-modal';

const useAddEditReviewTemplateModal = ({
  modalId = addEditReviewTemplateModalId,
}: {
  modalId?: string;
} = {}) => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();

  const openAddReviewTemplateModal = () => {
    openModal({
      id: modalId,
      title: t(
        'pageAutomations.reviews.guestReviewTemplates.addReviewTemplate',
      ),
      customContent: <AddEditReviewTemplateModal modalId={modalId} />,
    });
  };

  const openEditReviewTemplateModal = ({
    reviewTemplateUid,
    manualReviewPayload,
    isVrbo = false,
    customModalId = undefined,
  }: {
    reviewTemplateUid: string;
    manualReviewPayload?: AdditionalManualReviewPayload;
    isVrbo?: boolean;
    customModalId?: string;
  }) => {
    openModal({
      id: customModalId || modalId,
      title: manualReviewPayload
        ? t(
            'pageAutomations.reviews.guestReviewTemplates.modal.publishManualReview',
          )
        : t('pageAutomations.reviews.guestReviewTemplates.editReviewTemplate'),
      customContent: (
        <AddEditReviewTemplateModal
          modalId={customModalId || modalId}
          reviewTemplateUid={reviewTemplateUid}
          manualReviewPayload={manualReviewPayload ?? undefined}
          isVrbo={isVrbo}
        />
      ),
    });
  };

  return { openAddReviewTemplateModal, openEditReviewTemplateModal };
};

export default useAddEditReviewTemplateModal;
